import { Component, Input } from '@angular/core';
import { PollResponseDTO } from '../../model/PollResponseDTO';

export const NEGATIVE_RESPONSE_LIMIT = 5;
export const POSITIVE_RESPONSE_LIMIT = 5;

/**
 * Pregunta tal como la ve el colaborador al responder la encuesta.
 * Se usa en la encuesta y en la vista previa del alta de preguntas,
 * así ambas pantallas se ven siempre igual.
 */
@Component({
  selector: 'app-question-card',
  templateUrl: './question-card.component.html',
  styleUrls: ['./question-card.component.css']
})
export class QuestionCardComponent {

  @Input() question: PollResponseDTO;
  // { rate, feedback, isAnonymous }
  @Input() response: any;

  showFeedbackInput() {
    let response = this.response;
    let question = this.question;
    if (response != null && response.rate != null && question.isSupportsFeedback) {
      if (question.titleNegativeFeedback && question.titlePositiveFeedback) {
        return response.rate <= NEGATIVE_RESPONSE_LIMIT || response.rate >= POSITIVE_RESPONSE_LIMIT;
      }
      if (question.titleNegativeFeedback) {
        return response.rate <= NEGATIVE_RESPONSE_LIMIT;
      }
      if (question.titlePositiveFeedback) {
        return response.rate >= POSITIVE_RESPONSE_LIMIT;
      }
      return true;
    }
    return false;
  }

  feedbackInputTitle() {
    let response = this.response;
    let question = this.question;
    if (response != null && response.rate != null && question.isSupportsFeedback) {
      if (response.rate <= NEGATIVE_RESPONSE_LIMIT) {
        return question.titleNegativeFeedback;
      }
      if (response.rate >= POSITIVE_RESPONSE_LIMIT) {
        return question.titlePositiveFeedback;
      }
    }
    return "--";
  }

}
